import React, { useContext, useState } from 'react'

import Filter from './Filter'
import List from './List'
import DataContextProvider from './DataContext'
import Panel from '../../../elem/panel/Panel'
import { samplePanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
import { AppStateContext } from '../AppStateContext'
import SampleHeader from './SampleHeader'

const Explorer = ({ width }) => {
    const {
        filterState,
        updateFilterState,
        syncFilterState,
        togglePromotedRecords,
        promotedRecords,
    } = useContext(AppStateContext)

    const [isCollapsed, setCollapsed] = useState(false)
    const filterExpanded = filterState['sample']
    const toggleFilter = updateFilterState.bind(this, 'sample')

    return (
        <Panel
            componentWidth={width}
            panelClassConfig={panelClassConfig(width)}
        >
            <div className="explorerWrapper">
                <DataContextProvider>
                    <SampleHeader
                        filterExpanded={filterExpanded}
                        toggleFilter={toggleFilter}
                        promotedRecords={promotedRecords['sample']}
                        togglePromotedRecords={togglePromotedRecords}
                        setCollapsed={setCollapsed}
                        isCollapsed={isCollapsed}
                    />
                    <div className={isCollapsed ? `is-collapsed` : ``}>
                        <Filter
                            width={width}
                            filterExpanded={filterExpanded}
                            syncFilterState={syncFilterState}
                            promotedRecords={promotedRecords}
                        />
                        <List
                            filterExpanded={filterExpanded}
                            toggleFilter={toggleFilter}
                            promotedRecords={promotedRecords}
                        />
                    </div>
                </DataContextProvider>
            </div>
        </Panel>
    )
}

export default Explorer
